import React, { useState } from "react";
import {
  Box,
  IconButton,
  InputBase,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  Typography,
  Grid,
} from "@mui/material";
import { WSIcons } from "../../commonFunctions/iIcons";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export const ReportView: React.FC = () => {
  const reports = [
    {
      name: "Inventory Report",
      submenus: [
        "Closing stock",
        "Cost detail",
        "Daily item movement",
        "Goods Receipt note register",
        "Goods Receipt note tax report",
        "Indent register",
        "Intermediate BOM Report",
        "Inventory Transaction Report",
        "Issue Register",
        "Ite Over Stock",
        "Item Reorder",
        "Ite Stock",
        "Ite Stock Ledger",
        "Menu Item BOM Report",
        "Most/Least Purchase Report",
        "Physical Inventory Count Variance",
        "Physical Inventory Count with Computer stock",
        "Purchase Analysis",
        "Purchase Order Register",
        "Purchase Order Vs Goods Receipt note",
        "Receive Register",
        "Recommendesd Order Item Report",
        "WAC report",
      ],
    },
    {
      name: "Transaction Report",
      submenus: [
        "Advance Order Report",
        "Bufeffet Gest List",
        "Buffet Schedule List",
        "City Ledger Report",
        "Commision Report",
        "Complimentary Report",
        "Consolidated SYS Menu Item Sales Summary",
        "Cost of Sales Analysis Report",
        "Credit Card with Surcharge Report",
        "Daily Flash Report",
        "Daily Sales",
        "Daily Sales By Loyality Card",
        "Daily Sales Karachi",
        "Daily Sales with Raw Material Consumptic",
        "Driver Efficiency Report",
        "Food and Beverage Revenue Report",
        "Food Cost",
        "Food Cost Analysis Report",
        "Food Time Taen Report",
        "Group Sales Register",
        "Guest Information List",
        "KDS Report",
        "KOT Register",
        "Meal Plan Report",
        "Menu Item",
        "Menu Item Recipie Consumption Report",
        "Monthly Meal Plan Costing",
        "Monthly Sales Report",
        "Most/Least Sales Report",
        "No Charge Report",
        "Outstanding KOT Report",
        "Pax Analysis Report",
        "Raw Material Consumption By Menu Item",
        "Receipt Discount Details",
        "Receipt Vs Advance Order",
        "Receipt Vs KOT",
        "Revenue Summary",
        "Room Post",
        "Sales Analysis Report",
        "Sales And Profit Summary",
        "Sales By Categorywise Report",
        "Sales Commision Report",
        "Sales Register",
        "Sales Report",
        "Sales Return Register (Nepal) ",
        "Sales Summary",
        "Server Performance Report",
        "Surcharge Detail Report",
        "Table Reservation",
        "Tax Analysis By Pay Type",
        "Tax Analysis Report",
        "Tax Bifurcation Report",
        "Tax Report",
        "Vendor Payment Report",
        "Yearly Sales Report",
      ],
    },
    {
      name: "Cashier Report",
      submenus: [
        "Cash In/Cash Out Report",
        "Payent By User",
        "Shift Report",
        "Shift Report User",
        "Shift Report Pay Type Wise,User Wise",
      ],
    },
    {
      name: "Audit Trail Report",
      submenus: [
        "Login History",
        "Change Log",
        "Audit Trail Receipt",
        "Night Audit",
        "SMS Log Report",
        "User activity Log",
      ],
    },
    {
      name: "Credit Report",
      submenus: [
        "Credit Sales",
        "Credit History",
        "Account Payable",
        "Account Receivable",
        "Credit Note",
        "Direct Billing(Aging)",
        "Direct Billing(Register)",
        "Direct Billing(Vendor)",
        "Direct Billing Detail(Account Wise)",
        "Direct Billing Ledger",
        "Direct Billing Summary(Account Wise)",
        "No Charge Account Limit",
        "No Charge Account List",
        "Payable Receivable Mapping Log",
      ],
    },
    {
      name: "Void Transaction Report",
      submenus: [
        "Void Indent List",
        "Void Issue List",
        "Void KOT",
        "Void Purchase List",
        "Void Purchase Order List",
        "Void Receipt",
        "Void Settlment List",
        "Void Table Reservation",
      ],
    },
    {
      name: "Mini Report",
      submenus: [
        "Cashier Sales Report",
        "Cashier Sales Sessionwise Report",
        "FlashReport Terminalwise",
        "Menu Item Sales Report",
        "Payment Type Listing Report by Receiptwise",
        "Sales Report",
        "Sales Report with A/R & A/P",
        "Serving Period Summary Report",
        "Time wise Item Sales Report",
        "Void Transaction Listing",
      ],
    },
    {
      name: "Payroll Reports",
      submenus: [
        "Analysis Report",
        "Audit Trail Time Sheet Report",
        "Comparative Report",
        "Daily Time Sheet Report",
        "Daily Time Sheet withLeave Details",
        "Employee List",
        "Holiday List",
        "Hour Analysis Report",
        "Leave Application Report",
        "Leave Balance Report",
        "Leave Details Report",
        "Loan/Advance Report",
        "Monthly Time Sheet Report",
        "Pay Head List",
        "Payslip Report",
        "Short Hour/ Over Time Report",
        "Time Sheet Report",
        "Work Detail Report",
      ],
    },
    {
      name: "Gift Card Reports",
      submenus: [
        "Card Balance",
        "Card Recharge v/s Usage Count",
        "Card Recharge/ Redeem",
        "Card Sales By Category Type",
        "Card Statement",
        "Card Transaction List",
        "Card Transaction Sumary(Sales)",
        "Card Transaction with Item Detail",
        "Enrollment Deposit Report",
        "Loyalty Void Transaction",
        "VIP Report",
      ],
    },
    {
      name: "Banquet Reports",
      submenus: [
        "Banquet Availability Report",
        "Banquet Booking - Detail",
        "Banquet Booking - Summary",
        "Banquet Chart",
        "Banquet Daily Report",
        "Banquet Revenue Detail Report",
        "Banquet Revenue Report",
        "Cancellation Banquet Booking Report",
        "Vacant Banquet Detail",
        "Void Banquet Booking",
      ],
    },
    { name: "Charts", submenus: ["Sales Chart"] },
  ];

  // State to track which items are expanded
  const [openItems, setOpenItems] = useState<{ [key: string]: boolean }>({});

  // Toggle the open state for a specific report
  const handleToggle = (reportName: string) => {
    setOpenItems((prevState) => ({
      ...prevState,
      [reportName]: !prevState[reportName],
    }));
  };

  return (
    <Grid
      sx={{
        width: "250px",
        bgcolor: "#f5f5f5",
        height: "100vh",
        borderRight: "1px solid #ddd",
        p: 2,
      }}
    >
      {/* Search and Icons */}
      <Grid sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <InputBase
          placeholder="Search..."
          sx={{
            flex: 1,
            bgcolor: "#ffffff",
            padding: "4px 8px",
            borderRadius: 1,
          }}
        />
        <IconButton>
          <WSIcons.SearchIcon />
        </IconButton>
        <IconButton>
          <WSIcons.SyncIcon />
        </IconButton>
        <IconButton>
          <WSIcons.SortByAlphaIcon />
        </IconButton>
      </Grid>

      {/* Report List */}
      <List>
        {reports.map((report) => (
          <React.Fragment key={report.name}>
            <ListItem button onClick={() => handleToggle(report.name)}>
              <ListItemIcon>
                {openItems[report.name] ? (
                  <WSIcons.RemoveIcon />
                ) : (
                  <WSIcons.AddIcon />
                )}
              </ListItemIcon>
              <ListItemText
                primary={report.name}
                sx={{ color: "#555", fontSize: "0.8rem" }}
              />
            </ListItem>
            {/* Submenu List */}
            <Collapse in={openItems[report.name]} timeout="auto" unmountOnExit>
              <List
                component="div"
                disablePadding
                sx={{
                  maxHeight: "20rem", // Adjust this height as needed
                  overflowY: "auto",
                  "&::-webkit-scrollbar": { width: "6px" },
                  "&::-webkit-scrollbar-thumb": {
                    bgcolor: "#c1c1c1",
                    borderRadius: "4px",
                  },
                  "&::-webkit-scrollbar-track": { bgcolor: "#f5f5f5" },
                }}
              >
                {report.submenus.map((submenu, index) => (
                  <ListItem key={index} sx={{ pl: 4 }}>
                    <ListItemText
                      primary={submenu}
                      sx={{ fontSize: "0.8rem", color: "#777" }}
                    />
                  </ListItem>
                ))}
              </List>
            </Collapse>
          </React.Fragment>
        ))}
      </List>
         {/* Footer Section */}
         <Grid 
          container
          sx={{
            position: 'fixed',
            bottom: 0,
            left: '0.5rem',
            width: '100%',
            backgroundColor: '#f5f5f5',
            textAlign: 'center',
            padding: 2,
          }}
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item xs={12} sm={4}>
            <Typography variant="body2">System Date: 11-11-2024 Monday</Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="body2">Software Date: 09-10-2024 Wednesday</Typography>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Willsoar</Typography>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Live Support</Typography>
          </Grid>
        </Grid>
    </Grid>
  );
};
